import { snackBarError } from '#action/fetch';
import { webPortalApi } from '#config/web-portal-api';
import {
  SUCCESS
} from '#action/types';
import { updateShipmentEvents } from './overview';
import { getRequestOptions } from '#helper';

export const patchShipmentAlertAcceptance = (shipmentId, item, acceptance) => async dispatch => {
  try {
    const logId = item?.details?.logId;
    const res = await fetch(webPortalApi.buildApiUrl(`shipment/${shipmentId}/accept-alert/${logId}`), {
      method: 'PATCH',
      body: JSON.stringify(acceptance),
      ...getRequestOptions()
    });

    if (!res.ok) {
      throw await res.json();
    }

    dispatch(updateShipmentEvents({ newEvent: item, acceptance }));

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Alert has been accepted'
      }
    });

    return { success: true };
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    return { success: false };
  }
};

export const deleteShipmentAlertAcceptance = (shipmentId, item) => async dispatch => {
  try {
    const logId = item?.details?.logId;
    const url = webPortalApi.buildApiUrl(`shipment/${shipmentId}/accept-alert/${logId}`);
    const res = await fetch(url, {
      method: 'DELETE',
      ...getRequestOptions()
    });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    if (!res.ok) {
      throw await res.json();
    }

    dispatch(updateShipmentEvents({ newEvent: item }));

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Acceptance has been deleted'
      }
    });

    return await res.json();
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    return { success: false };
  }
};
